import React from "react"
import { useTranslation } from "react-i18next"
import { Modal, ModalHeader, ModalBody, Button } from "reactstrap"

const HTMLModal = ({ isOpen, toggle, dangerousHTML }) => {
  const { t } = useTranslation()
  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" centered>
      <ModalHeader toggle={toggle}>{t("Preview")}</ModalHeader>
      <ModalBody>
        <div dangerouslySetInnerHTML={{ __html: dangerousHTML }} />
      </ModalBody>
    </Modal>
  )
}

export default HTMLModal
